import { Badge, Box, Breadcrumbs, Grid, Typography } from "@mui/material";
import DashboardLayout from "../../../../layout/DashboardLayout/DashboardLayout";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import BreadcrumbSection from "../../../../components/BreadcrumbSection/BreadcrumbSection";
import {
  getAccessToken,
  isCurrentAdminFromRootOrganization,
  isCurrentAdminSuperAdmin,
} from "../../../../helpers/authHelpers";
import { useState } from "react";
import {
  DataGrid,
  GridActionsCellItem,
  GridCellParams,
  GridColDef,
  GridFilterModel,
  GridLogicOperator,
  GridPaginationModel,
  GridSortModel,
} from "@mui/x-data-grid";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { darken, lighten, styled } from "@mui/material/styles";
import PaginationTable from "../../../../components/PaginationTable/PaginationTable";
import moment from "moment";
import {
  mappedCouponDeductionTypes,
  mappedCouponDurationTypes,
  mappedVehicleTypes,
  toTitleCase,
} from "../../../../helpers/validationHelpers";
import useCSVDownloadState from "../../../../hooks/useCSVDownloadState";
import { AuthContext } from "../../../../context/authContext";
import { userAuthState } from "../../../../atom";
import { useRecoilState } from "recoil";
import AddNewDriverModal from "../../../Organizations/OrganizationDetails/OrganizationDriversTab/AddNewDriverModal/AddNewDriverModal";
import Button from "../../../../components/Button/Button";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import useAdminNearbyDriversSocket from "../../../../sockets/useAdminNearbyDriversSocket";
import {
  getPromoCodesCSV,
  usePromoCodeRedemptions,
  usePromoCodes,
} from "../../../../hooks/usePromoCodes";
import AddNewPromoCodeModal from "../../../PromoCodes/AddNewPromoCodeModal/AddNewPromoCodeModal";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { roundToPrecision } from "../../../../helpers/formatters";

const PromoCodeRedemptionsTab = ({ promoCodeId }: { promoCodeId?: string }) => {
  //   const {
  //     csvDownloadLoading: promoCodesCsvDownloadLoading,
  //     setCsvDownloadLoading: setPromoCodesCsvDownloadLoading,
  //     csvData: promoCodesCsvData,
  //     setCsvData: setPromoCodesCsvData,
  //     setCsvFilename: setPromoCodesCsvFilename,
  //     csvLinkRef: promoCodesCsvLinkRef,
  //     setShouldDownload: setShouldDownloadPromoCodesCsv,
  //   } = useCSVDownloadState();

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [filterModel, setFilterModel] = useState<GridFilterModel>({
    items: [],
    quickFilterValues: [],
    logicOperator: GridLogicOperator.And,
    quickFilterLogicOperator: GridLogicOperator.And,
  });

  const [sortModel, setSortModel] = useState<GridSortModel>([
    {
      field: "createdAt",
      sort: "desc",
    },
  ]);
  const [showAddPromoCodeModal, setShowAddPromoCodeModal] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const [authDetails, setAuthDetails] = useRecoilState(userAuthState);
  const { nearbyDrivers, isDriverOnline } = useAdminNearbyDriversSocket({
    accessToken: authDetails?.accessToken,
  });

  const {
    data: promoCodesData,
    isLoading,
    isFetching,
  } = usePromoCodeRedemptions({
    accessToken: authDetails?.accessToken,
    promoCodeId,
    page: paginationModel.page,
    search: filterModel?.quickFilterValues?.join(" "),
    sort: sortModel,
  });

  console.log("promo code redemptions tab", promoCodesData);

  const handlePaginationModelChange = async (model: GridPaginationModel) => {
    setPaginationModel(model);
  };

  const handleFilterModelChange = async (model: GridFilterModel) => {
    setFilterModel(model);
  };

  const handleSortModelChange = async (model: GridSortModel) => {
    setSortModel(model);
  };

  const columns: GridColDef[] = [
    {
      field: "pickUpRequestId",
      headerName: "Pick Up Request ID",
      width: 150,
      renderCell: (params) => (
        <Link
          to={`/dashboard/service-calls/${params?.row?.pickUpRequestId}`}
          state={{ prevPage: location.pathname }}
        >
          {params?.row?.id}
        </Link>
      ),
    },
    {
      field: "pickUpAddress",
      headerName: "Pick Up Address",
      width: 200,
      valueGetter: (params) =>
        params?.row?.pickUpRequest?.pickUpRequestLocationDetails?.originAddress,
    },
    {
      field: "destinationAddress",
      headerName: "Drop Off Address",
      width: 200,
      valueGetter: (params) =>
        params?.row?.pickUpRequest?.pickUpRequestLocationDetails
          ?.destinationAddress,
    },
    {
      field: "totalFare",
      headerName: "Total Fare ($)",
      valueGetter: (params) =>
        roundToPrecision(
          (params?.row?.pickUpRequest?.price +
            params?.row?.pickUpRequest?.taxAmountInCents +
            params?.row?.pickUpRequest?.tipAmountInCents) /
            100,
          2
        ),
    },
    {
      field: "redeemedByUser",
      headerName: "Redeemed By",
      width: 125,
      editable: true,
      renderCell: (params) =>
        params?.row?.redeemedByUser ? (
          <Link
            to={`/dashboard/customers/${params?.row?.redeemedByUserId}`}
            state={{ prevPage: location.pathname }}
          >
            {params?.row?.redeemedByUser?.firstName}{" "}
            {params?.row?.redeemedByUser?.lastName}
          </Link>
        ) : (
          <Typography>N/A</Typography>
        ),
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 100,
      renderCell: (params) => (
        <Typography>
          {moment(params.row.createdAt).format("DD/MM/YYYY")}
        </Typography>
      ),
    },
    // {
    //   field: "actions",
    //   headerName: "Actions",
    //   type: "actions",
    //   getActions: (params) => [
    //     <GridActionsCellItem
    //       icon={<VisibilityOutlinedIcon />}
    //       onClick={() => {
    //         navigate(`/dashboard/promo-codes/${params.row.id}`, {
    //           state: {
    //             prevPage: location.pathname,
    //           },
    //         });
    //       }}
    //       label="View"
    //     />,
    //   ],
    // },
  ];

  //   const downloadPromoCodesCsv = async () => {
  //     setPromoCodesCsvDownloadLoading(true);
  //     try {
  //       const result = await getPromoCodesCSV(
  //         authDetails?.accessToken,
  //         organizationId
  //       );
  //       setPromoCodesCsvData(result?.data);
  //       setPromoCodesCsvFilename(result?.filename);
  //       setShouldDownloadPromoCodesCsv(true);
  //     } catch (error) {
  //       console.log("error", error);
  //     } finally {
  //       setPromoCodesCsvDownloadLoading(false);
  //     }
  //   };

  return (
    <Grid
      sx={{ padding: 2, position: "relative" }}
      container
      direction={"column"}
    >
      <Grid container pb={4}>
        <PaginationTable
          withExport={false}
          withSearchBar
          columns={columns}
          loading={isLoading || isFetching}
          rows={promoCodesData?.data ?? []}
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={(model: any) => {
            handlePaginationModelChange(model);
          }}
          filterMode="server"
          filterModel={filterModel}
          onFilterModelChange={(model: any) => {
            handleFilterModelChange(model);
          }}
          sortingMode="server"
          sortModel={sortModel}
          onSortModelChange={(model: any) => {
            handleSortModelChange(model);
          }}
          totalCount={promoCodesData?.totalCount}
          pageCount={promoCodesData?.totalPages}
        />
      </Grid>
      {/* {promoCodesCsvData && (
        <a
          style={{ display: "none" }}
          ref={promoCodesCsvLinkRef}
          href={`data:text/csv;charset=utf-8,${escape(promoCodesCsvData)}`}
          download="filename.csv"
        >
          download
        </a>
      )} */}
    </Grid>
  );
};

export default PromoCodeRedemptionsTab;
